module.exports = __webpack_public_path__ + "70f5eeace0e031e8822b4b2eb1b26e33.png";